module.exports = __webpack_public_path__ + "img/tn_logo.0a31e38b.png";